import { useMemo } from 'react';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const useDayRelationOptionsGet = () => {
  const options = useMemo(
    () => [
      { id: '0', label: 'Day of - Day of', value: 0 },
      { id: '1', label: 'Day of - Day after', value: 1 },
      { id: '2', label: 'Day before - Day of', value: 2 },
    ],
    []
  );
  return { options, isLoading: false, isSuccess: true };
};

const dataFetcher = useDayRelationOptionsGet;
type ExtraParameters = unknown;
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({});

export const {
  DayRelationSelectField,
  DayRelationFormSelectField,
  DayRelationDataGridSelectField,
  DayRelationIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'DayRelation',
  useOptionsHook: dataFetcher,
  extractHookParams: hookParamsGetter,
});
